export default __webpack_public_path__ + "static/media/fw-harper-er-White Gold.8ea4c145.mp4";